import * as React from "react";
import PulseChat from "../app/components/PulseChat";
import { pageTitle, cardShell } from "../app/glass/styles";
import { useTranslation } from "react-i18next";

const Pulse = () => {
  const { t } = useTranslation();
  return (
    <>
      <div style={{ ...pageTitle, marginTop: 6 }}>{t("pulse.title")}</div>
      <div style={{ ...cardShell, padding: 0, overflow: "hidden", height: "calc(100vh - 180px)", minHeight: 480 }}>
        <PulseChat variant="page" />
      </div>
    </>
  );
};

export default Pulse;
